import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { slicesToFilters } from "components/common/PaginatedEntityTable/useFetchEntities";
const filtersToURLParams = (filters) => {
  var _a;
  return ((_a = FiltersForQueryParams(filters)) != null ? _a : []).map((filter) => `filters=${encodeURIComponent(filter)}`);
};
export function parseSearchParamsToURLString(inSearchParams) {
  const searchParams = slicesToFilters(inSearchParams);
  const {
    page,
    pageSize,
    sort: { attributeId, direction },
    query,
    filters
  } = searchParams;
  const params = [`page=${page}`, `per_page=${pageSize}`, `sort=${attributeId}`, `order=${direction}`];
  if (query) params.push(`query=${encodeURIComponent(query)}`);
  return [...params, ...filtersToURLParams(filters)].join("&");
}
export function parseSliceParamsToURLString(sliceColumn, query, filters) {
  const params = [`slice_column=${encodeURIComponent(sliceColumn)}`];
  if (query) params.push(`query=${encodeURIComponent(query)}`);
  return [...params, ...filtersToURLParams(filters)].join("&");
}
export function parseFilterValuesParamsToURLString(field, { valueQuery, page, pageSize }, query, filters) {
  const params = [`field=${encodeURIComponent(field)}`, `page=${page}`, `per_page=${pageSize}`];
  if (valueQuery) params.push(`value_query=${encodeURIComponent(valueQuery)}`);
  if (query) params.push(`query=${encodeURIComponent(query)}`);
  return [...params, ...filtersToURLParams(filters)].join("&");
}
